import {
  Cable, Lightbulb, Zap, Plug, ShieldAlert,
  BatteryCharging, Building2, ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: Cable,
    title: "Full & Partial Rewires",
    desc: "Complete domestic rewires, consumer unit upgrades, and partial rewires — minimal disruption, certified work.",
    span: "lg:col-span-2",
  },
  {
    icon: Lightbulb,
    title: "Lighting Design & Install",
    desc: "Interior, exterior, downlights, garden lighting.",
  },
  {
    icon: Zap,
    title: "Fuse Boards",
    desc: "Modern consumer unit upgrades and RCD protection.",
  },
  {
    icon: Plug,
    title: "Sockets & Switches",
    desc: "Additional sockets, USB outlets, smart switches.",
  },
  {
    icon: ShieldAlert,
    title: "EICR & Safety Reports",
    desc: "Landlord & homeowner electrical safety certificates.",
  },
  {
    icon: BatteryCharging,
    title: "EV Charger Installation",
    desc: "Home charge points from leading brands — OZEV approved installs.",
    span: "lg:col-span-2",
  },
  {
    icon: Building2,
    title: "Commercial & Landlord",
    desc: "Offices, shops, HMO landlords — scheduled maintenance and certification.",
  },
];

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="relative bg-[#0A0A0A] py-28 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      {/* Heading */}
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
              01 — Services
            </span>
            <span className="h-px w-12 bg-[#1E90FF]/40" />
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05] tracking-tight max-w-3xl"
            style={{ fontFamily: "Outfit" }}
          >
            From a single socket
            <br />
            to the whole house.
          </h2>
        </div>
        <p className="text-[#A0AAB2] text-base lg:text-lg max-w-md leading-relaxed">
          Every job — large or small — completed to current regulations and
          finished with care. Honest pricing, transparent rates, no surprises.
        </p>
      </div>

      {/* Bento grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
        {SERVICES.map((s, i) => (
          <div
            key={s.title}
            data-testid={`service-${s.title.toLowerCase().replace(/\s|&/g, "-")}`}
            className={`relative bg-[#0F0F0F] p-6 lg:p-7 group cursor-pointer corner-accent transition-all duration-500 hover:bg-[#141414] ${s.span || ""}`}
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-12 h-12 border border-white/10 flex items-center justify-center group-hover:border-[#1E90FF] group-hover:bg-[#1E90FF]/5 transition-all duration-300">
                <s.icon className="w-5 h-5 text-[#1E90FF]" strokeWidth={1.5} />
              </div>
              <span className="text-[10px] tracking-[0.25em] text-[#A0AAB2]/60 uppercase">
                / {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3
              className="text-xl text-white font-medium mb-2 leading-tight"
              style={{ fontFamily: "Outfit" }}
            >
              {s.title}
            </h3>
            <p className="text-[#A0AAB2] text-sm leading-relaxed">{s.desc}</p>
            <div className="mt-5 flex items-center gap-2 text-[#1E90FF] text-xs tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <span>Enquire</span>
              <ArrowUpRight className="w-3.5 h-3.5" />
            </div>
          </div>
        ))}

        {/* Final CTA card */}
        <div
          data-testid="service-other-card"
          className="relative bg-gradient-to-br from-[#1E90FF]/15 via-[#0F0F0F] to-[#0F0F0F] p-6 lg:p-7 flex flex-col justify-between"
        >
          <div>
            <div className="text-[10px] tracking-[0.3em] text-[#1E90FF] uppercase mb-3">
              + Anything else
            </div>
            <h3 className="text-xl text-white font-medium leading-tight" style={{ fontFamily: "Outfit" }}>
              Not sure if we cover it? We probably do.
            </h3>
          </div>
          <a
            href="#contact"
            data-testid="service-ask-button"
            className="mt-5 inline-flex items-center gap-2 text-white text-sm font-medium border-b border-[#1E90FF] pb-1 w-fit hover:gap-3 transition-all"
          >
            Ask Ernest <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  </section>
);
